import {COST_BEARER_OWN, COST_BEARER_RENTER} from "../api/dtos/dtos";
import {RadioProps} from "antd/lib/radio/interface";
import locales from "../locales";

interface CostMap {
  [key: string]: CostOption
}

interface CostOption {
  defaultTravelDistance: number;
  defaultTravelCost: number;
  defaultRepairTime: number;
  defaultRepairCost: number;
}

export const maintenanceValues: CostMap = {
  [COST_BEARER_OWN]: {
    defaultTravelDistance: 0,
    defaultTravelCost: 180,
    defaultRepairTime: 0,
    defaultRepairCost: 8000,
  },
  [COST_BEARER_RENTER]: {
    defaultTravelDistance: 0,
    defaultTravelCost: 300,
    defaultRepairTime: 0,
    defaultRepairCost: 15000,
  },
}

export const costBearerOptions: RadioProps[] = [{
  value: COST_BEARER_RENTER,
  name: locales.cost_renter,
}, {
  value: COST_BEARER_OWN,
  name: locales.cost_own,
}];

export interface CostCalcArgs {
  travelDistance?: number;
  travelCost?: number;
  repairTime?: number;
  repairCost?: number;
}


// WEBPACK FOOTER //
// ./src/maintenance/MaintenanceTypes.tsx